// pages/admin/Horarios.jsx
import { useEffect, useState } from 'react';
import {
  Box, Typography, MenuItem, Select, FormControl, InputLabel
} from '@mui/material';
import { useLocations } from '../../../hook/useLocations';
import BusinessHoursEditor from './BusinessHoursEditor';


const InfoHours = () => {

  const {loading, getLocations, location} = useLocations();
  const [selected, setSelected] = useState(null);
  const [refresh, setRefresh] = useState(null); 
  

    const onRefresh = () => {setRefresh(prev =>!prev)} 
  
    useEffect(() => {
        getLocations();
    
    }, [refresh])



  const handleSelect = (id) => {
    const loc = location.find(l => l.id === parseInt(id));
    setSelected(loc);
  };
  console.log(location);
  
  if (loading) return <Typography>Cargando sedes...</Typography>;

  return (
    <Box p={4}>
      <Typography variant="h4" mb={2}>Configuración de Horarios</Typography>
      <FormControl fullWidth>
        <InputLabel>Selecciona una sede</InputLabel>
        <Select onChange={(e) => handleSelect(e.target.value)} label="Selecciona una sede">
          {location.map(loc => (
            <MenuItem key={loc.id} value={loc.id}>{loc.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      {selected && <BusinessHoursEditor location={selected} onRefresh={onRefresh} />}
    </Box>
  );
};

export default InfoHours;
